import type { CSSProperties, ReactNode } from "react";
import { Box } from "@mantine/core";

interface ReportMediaFrameProps {
  children: ReactNode;
  height?: CSSProperties["height"];
}

export function ReportMediaFrame(props: ReportMediaFrameProps) {
  const { children, height } = props;
  return (
    <Box
      data-report-media-frame
      w="100%"
      style={
        height
          ? {
              alignItems: "flex-end",
              display: "flex",
              height,
              justifyContent: "center",
            }
          : undefined
      }
    >
      {children}
    </Box>
  );
}
